export default __webpack_public_path__ + "static/media/WhaleCamera.78950db9.png";